// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =========================================================
   Tool Base Layout
   ========================================================= */

.tool {
  margin: 0 auto;
  padding-bottom: 40px;
  padding-top: 20px;
  display: flex;
  flex-direction: column;
  gap: 0px;
}

/* =========================================================
   Tool Header
   ========================================================= */

.tool-header {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.tool-title {
  font-size: 1.5rem;
  font-weight: 600;
  color: #111827;
  margin: 0;

  text-align: center;
}

.tool-description {
  font-size: 0.95rem;
  color: #6b7280;
  font-weight: 500;
  
}

/* =========================================================
   Sections
   ========================================================= */

.tool-section {
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

/* =========================================================
   Form Layout
   ========================================================= */

.tool-form {
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;
}

@media (min-width: 550px) {
  .tool-form {
    grid-template-columns: repeat(2, 1fr);
  }
}

.tool-form-row {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

/* =========================================================
   Inputs
   ========================================================= */

.tool-label {
  font-size: 0.99rem;
  font-weight: 700;
  color: #374151;
  padding-top: 10px;
}

.tool-input,
.tool-select,
.tool-textarea {
  padding: 10px 12px;
  border-radius: 6px;
  border: 1px solid #d1d5db;
  font-size: 0.95rem;
  width: 100%;
}

.tool-input:focus,
.tool-select:focus,
.tool-textarea:focus {
  outline: none;
  border-color: #2563eb;
  box-shadow: 0 0 0 1px #2563eb;
}

/* =========================================================
   Actions
   ========================================================= */

.tool-actions {
  padding-top: 20px;
  display: flex;
  justify-content: center;
  gap: 12px;
}

.tool-button-primary {
  background: #2563eb;
  color: #ffffff;
  border: none;
  border-radius: 6px;
  padding: 10px 16px;
  font-size: 0.95rem;
  font-weight: 500;
  cursor: pointer;
}

.tool-button-primary:hover {
  background: #1d4ed8;
}

.tool-button-secondary {
  background: #f9fafb;
  color: #374151;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  padding: 10px 16px;
  font-size: 0.95rem;
  cursor: pointer;
}

.tool-button-secondary:hover {
  background: #f3f4f6;
}

html[data-brand="house-helper"] .tool-input:focus,
html[data-brand="house-helper"] .tool-select:focus,
html[data-brand="house-helper"] .tool-textarea:focus {
  border-color: #2f7d32;
  box-shadow: 0 0 0 1px #2f7d32;
}

html[data-brand="house-helper"] .tool-button-primary {
  background: #2f7d32;
}

html[data-brand="house-helper"] .tool-button-primary:hover {
  background: #1b5e20;
}

html[data-brand="house-helper"] .tool-section,
html[data-brand="house-helper"] .tool-result-card {
  border-color: rgba(47, 125, 50, 0.14);
}

/* =========================================================
   Results / Output
   ========================================================= */

.tool-results {
  

  display: flex;
  flex-direction: column;
  gap: 12px;
}

.tool-result-card {
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 16px;
}

/* =========================================================
   Utility
   ========================================================= */

.tool-muted {
  color: #6b7280;
  font-size: 1.09rem;
  text-align: left;
  width: 101%;
}

.tool-field-error {
  color: #b42318;
  font-size: 0.92rem;
  line-height: 1.4;
}

.tool-divider {
  height: 1px;
  background: #e5e7eb;
  margin: 12px 0;
}

/* =========================================================
   Cost Estimator – Streaming Layout
   ========================================================= */

.estimate-layout {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 0px;
  width: 102%;
}


/* Avatar image */
.estimate-avatar img {
  max-width: 122px;
  min-width: 122px;
  width: 100%;
}

.tool-page-inner {
  width:86%;
}

/* =========================================================
   Cost Estimator – Wrapped Streaming Layout
   ========================================================= */

.estimate-layout {
  display: block; /* remove flex behavior */
  width: 100%;
}

.estimate-avatar {
  float: left;
  margin: 0 14px 8px 0;
}

.estimate-avatar img {
  height: auto;
  -webkit-mask-image: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 1) calc(100% - 55%),
    rgba(0, 0, 0, 0) 100%
  );
  mask-image: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 1) calc(100% - 55px),
    rgba(0, 0, 0, 0) 100%
  );
}

/* Streaming text flows naturally */
.estimate-stream {
  display: block;
}

/* Clear float so footer/layout doesn't break */
.estimate-layout::after {
  content: "";
  display: table;
  clear: both;
}

/* Desktop tuning */
@media (min-width: 550px) {
  .estimate-avatar img {
    max-width: 220px;
    -webkit-mask-image: linear-gradient(
      to bottom,
      rgba(0, 0, 0, 1) calc(100% - 35px),
      rgba(0, 0, 0, 0) 100%
    );
    mask-image: linear-gradient(
      to bottom,
      rgba(0, 0, 0, 1) calc(100% - 35px),
      rgba(0, 0, 0, 0) 100%
    );
  }
}


/* Desktop layout */
@media (min-width: 550px) {
  .estimate-layout {
    flex-direction: row;
    align-items: flex-start;
    gap: 0px;
  }

  .estimate-avatar {
    flex: 0 0 240px;
    margin: 0;
  }

  .estimate-stream {
    flex: 1;
    margin-left: 75px;
  }
  .estimate-avatar img {
    max-width: 129px;
    width: 100%;
  }
  .tool-title {
    font-size: 1.5rem;
    font-weight: 600;
    color: #111827;
    margin: 0;

    text-align: left;
  }
  .tool {
    max-width: 650px;
    margin: 0 auto;
    padding-bottom: 40px;
    display: flex;
    flex-direction: column;
    gap: 0px;
  }
}






.estimate-content {
  font-size: 18px;
  line-height: 1.6;
  color: #2b2b2b;
  margin-left: 0;
}

.estimate-content h2,
.estimate-content h3 {
  margin-top: 20px;
  margin-bottom: 10px;
  font-weight: 600;
  text-align: left;
}

.estimate-content ul,
.estimate-content ol {
  margin-bottom: 16px;
  margin-left: -18px;
}

.estimate-content li {
  margin-bottom: 6px;
}

.estimate-content strong {
  font-weight: 600;
}

.estimate-content p {
  margin-bottom: 14px;
}

.project-readiness-form {
  margin-top: 8px;
}

.project-readiness-checkbox {
  display: flex;
  align-items: center;
  gap: 10px;
  padding-top: 8px;
}

.project-readiness-checkbox input {
  margin: 0;
}

.project-readiness-reveal {
  margin-top: 10px;
  padding: 14px 16px;
  border: 1px solid #dbe6ff;
  border-radius: 8px;
  background: #f8fbff;
}

.project-readiness-context {
  margin-top: 4px;
}

.project-readiness-badge-row {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 14px;
}

.project-readiness-badge,
.project-readiness-confidence {
  display: inline-flex;
  align-items: center;
  min-height: 34px;
  padding: 6px 12px;
  border-radius: 999px;
  background: #eff6ff;
  color: #1d4ed8;
  font-size: 0.9rem;
  font-weight: 600;
}

html[data-brand="house-helper"] .project-readiness-badge,
html[data-brand="house-helper"] .project-readiness-confidence {
  background: #edf8e7;
  color: #2f7d32;
}

.project-readiness-summary-copy {
  margin-top: 14px;
  color: #1f2937;
  line-height: 1.6;
}

.project-readiness-list {
  margin: 12px 0 0;
  padding-left: 18px;
  color: #374151;
  line-height: 1.6;
}

.project-readiness-results-actions {
  justify-content: flex-start;
  padding-top: 12px;
}

.project-readiness-cta-link {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
}
`, "",{"version":3,"sources":["webpack://./src/assets/stylesheets/toolBase.css"],"names":[],"mappings":"AAAA;;8DAE8D;;AAE9D;EACE,cAAc;EACd,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;;8DAE8D;;AAE9D;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,SAAS;;EAET,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;;AAElB;;AAEA;;8DAE8D;;AAE9D;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;;8DAE8D;;AAE9D;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;AACX;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;;8DAE8D;;AAE9D;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;;;EAGE,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;AACb;;AAEA;;;EAGE,aAAa;EACb,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;;8DAE8D;;AAE9D;EACE,iBAAiB;EACjB,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;EAGE,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,qCAAqC;AACvC;;AAEA;;8DAE8D;;AAE9D;;;EAGE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;AACf;;AAEA;;8DAE8D;;AAE9D;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;8DAE8D;;AAE9D;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,WAAW;AACb;;;AAGA,iBAAiB;AACjB;EACE,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,SAAS;AACX;;AAEA;;8DAE8D;;AAE9D;EACE,cAAc,EAAE,yBAAyB;EACzC,WAAW;AACb;;AAEA;EACE,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ;;;;GAIC;EACD;;;;GAIC;AACH;;AAEA,mCAAmC;AACnC;EACE,cAAc;AAChB;;AAEA,+CAA+C;AAC/C;EACE,WAAW;EACX,cAAc;EACd,WAAW;AACb;;AAEA,mBAAmB;AACnB;EACE;IACE,gBAAgB;IAChB;;;;KAIC;IACD;;;;KAIC;EACH;AACF;;;AAGA,mBAAmB;AACnB;EACE;IACE,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;EACV;;EAEA;IACE,eAAe;IACf,SAAS;EACX;;EAEA;IACE,OAAO;IACP,iBAAiB;EACnB;EACA;IACE,gBAAgB;IAChB,WAAW;EACb;EACA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,SAAS;;IAET,gBAAgB;EAClB;EACA;IACE,gBAAgB;IAChB,cAAc;IACd,oBAAoB;IACpB,aAAa;IACb,sBAAsB;IACtB,QAAQ;EACV;AACF;;;;;;;AAOA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;;EAEE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;EAEE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,gBAAgB;AAClB;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;AACvB","sourcesContent":["/* =========================================================\n   Tool Base Layout\n   ========================================================= */\n\n.tool {\n  margin: 0 auto;\n  padding-bottom: 40px;\n  padding-top: 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 0px;\n}\n\n/* =========================================================\n   Tool Header\n   ========================================================= */\n\n.tool-header {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.tool-title {\n  font-size: 1.5rem;\n  font-weight: 600;\n  color: #111827;\n  margin: 0;\n\n  text-align: center;\n}\n\n.tool-description {\n  font-size: 0.95rem;\n  color: #6b7280;\n  font-weight: 500;\n  \n}\n\n/* =========================================================\n   Sections\n   ========================================================= */\n\n.tool-section {\n  background: #ffffff;\n  border: 1px solid #e5e7eb;\n  border-radius: 10px;\n  padding: 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n/* =========================================================\n   Form Layout\n   ========================================================= */\n\n.tool-form {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 16px;\n}\n\n@media (min-width: 550px) {\n  .tool-form {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n.tool-form-row {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n/* =========================================================\n   Inputs\n   ========================================================= */\n\n.tool-label {\n  font-size: 0.99rem;\n  font-weight: 700;\n  color: #374151;\n  padding-top: 10px;\n}\n\n.tool-input,\n.tool-select,\n.tool-textarea {\n  padding: 10px 12px;\n  border-radius: 6px;\n  border: 1px solid #d1d5db;\n  font-size: 0.95rem;\n  width: 100%;\n}\n\n.tool-input:focus,\n.tool-select:focus,\n.tool-textarea:focus {\n  outline: none;\n  border-color: #2563eb;\n  box-shadow: 0 0 0 1px #2563eb;\n}\n\n/* =========================================================\n   Actions\n   ========================================================= */\n\n.tool-actions {\n  padding-top: 20px;\n  display: flex;\n  justify-content: center;\n  gap: 12px;\n}\n\n.tool-button-primary {\n  background: #2563eb;\n  color: #ffffff;\n  border: none;\n  border-radius: 6px;\n  padding: 10px 16px;\n  font-size: 0.95rem;\n  font-weight: 500;\n  cursor: pointer;\n}\n\n.tool-button-primary:hover {\n  background: #1d4ed8;\n}\n\n.tool-button-secondary {\n  background: #f9fafb;\n  color: #374151;\n  border: 1px solid #e5e7eb;\n  border-radius: 6px;\n  padding: 10px 16px;\n  font-size: 0.95rem;\n  cursor: pointer;\n}\n\n.tool-button-secondary:hover {\n  background: #f3f4f6;\n}\n\nhtml[data-brand=\"house-helper\"] .tool-input:focus,\nhtml[data-brand=\"house-helper\"] .tool-select:focus,\nhtml[data-brand=\"house-helper\"] .tool-textarea:focus {\n  border-color: #2f7d32;\n  box-shadow: 0 0 0 1px #2f7d32;\n}\n\nhtml[data-brand=\"house-helper\"] .tool-button-primary {\n  background: #2f7d32;\n}\n\nhtml[data-brand=\"house-helper\"] .tool-button-primary:hover {\n  background: #1b5e20;\n}\n\nhtml[data-brand=\"house-helper\"] .tool-section,\nhtml[data-brand=\"house-helper\"] .tool-result-card {\n  border-color: rgba(47, 125, 50, 0.14);\n}\n\n/* =========================================================\n   Results / Output\n   ========================================================= */\n\n.tool-results {\n  \n\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.tool-result-card {\n  background: #f9fafb;\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  padding: 16px;\n}\n\n/* =========================================================\n   Utility\n   ========================================================= */\n\n.tool-muted {\n  color: #6b7280;\n  font-size: 1.09rem;\n  text-align: left;\n  width: 101%;\n}\n\n.tool-field-error {\n  color: #b42318;\n  font-size: 0.92rem;\n  line-height: 1.4;\n}\n\n.tool-divider {\n  height: 1px;\n  background: #e5e7eb;\n  margin: 12px 0;\n}\n\n/* =========================================================\n   Cost Estimator – Streaming Layout\n   ========================================================= */\n\n.estimate-layout {\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  gap: 0px;\n  width: 102%;\n}\n\n\n/* Avatar image */\n.estimate-avatar img {\n  max-width: 122px;\n  min-width: 122px;\n  width: 100%;\n}\n\n.tool-page-inner {\n  width:86%;\n}\n\n/* =========================================================\n   Cost Estimator – Wrapped Streaming Layout\n   ========================================================= */\n\n.estimate-layout {\n  display: block; /* remove flex behavior */\n  width: 100%;\n}\n\n.estimate-avatar {\n  float: left;\n  margin: 0 14px 8px 0;\n}\n\n.estimate-avatar img {\n  height: auto;\n  -webkit-mask-image: linear-gradient(\n    to bottom,\n    rgba(0, 0, 0, 1) calc(100% - 55%),\n    rgba(0, 0, 0, 0) 100%\n  );\n  mask-image: linear-gradient(\n    to bottom,\n    rgba(0, 0, 0, 1) calc(100% - 55px),\n    rgba(0, 0, 0, 0) 100%\n  );\n}\n\n/* Streaming text flows naturally */\n.estimate-stream {\n  display: block;\n}\n\n/* Clear float so footer/layout doesn't break */\n.estimate-layout::after {\n  content: \"\";\n  display: table;\n  clear: both;\n}\n\n/* Desktop tuning */\n@media (min-width: 550px) {\n  .estimate-avatar img {\n    max-width: 220px;\n    -webkit-mask-image: linear-gradient(\n      to bottom,\n      rgba(0, 0, 0, 1) calc(100% - 35px),\n      rgba(0, 0, 0, 0) 100%\n    );\n    mask-image: linear-gradient(\n      to bottom,\n      rgba(0, 0, 0, 1) calc(100% - 35px),\n      rgba(0, 0, 0, 0) 100%\n    );\n  }\n}\n\n\n/* Desktop layout */\n@media (min-width: 550px) {\n  .estimate-layout {\n    flex-direction: row;\n    align-items: flex-start;\n    gap: 0px;\n  }\n\n  .estimate-avatar {\n    flex: 0 0 240px;\n    margin: 0;\n  }\n\n  .estimate-stream {\n    flex: 1;\n    margin-left: 75px;\n  }\n  .estimate-avatar img {\n    max-width: 129px;\n    width: 100%;\n  }\n  .tool-title {\n    font-size: 1.5rem;\n    font-weight: 600;\n    color: #111827;\n    margin: 0;\n\n    text-align: left;\n  }\n  .tool {\n    max-width: 650px;\n    margin: 0 auto;\n    padding-bottom: 40px;\n    display: flex;\n    flex-direction: column;\n    gap: 0px;\n  }\n}\n\n\n\n\n\n\n.estimate-content {\n  font-size: 18px;\n  line-height: 1.6;\n  color: #2b2b2b;\n  margin-left: 0;\n}\n\n.estimate-content h2,\n.estimate-content h3 {\n  margin-top: 20px;\n  margin-bottom: 10px;\n  font-weight: 600;\n  text-align: left;\n}\n\n.estimate-content ul,\n.estimate-content ol {\n  margin-bottom: 16px;\n  margin-left: -18px;\n}\n\n.estimate-content li {\n  margin-bottom: 6px;\n}\n\n.estimate-content strong {\n  font-weight: 600;\n}\n\n.estimate-content p {\n  margin-bottom: 14px;\n}\n\n.project-readiness-form {\n  margin-top: 8px;\n}\n\n.project-readiness-checkbox {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding-top: 8px;\n}\n\n.project-readiness-checkbox input {\n  margin: 0;\n}\n\n.project-readiness-reveal {\n  margin-top: 10px;\n  padding: 14px 16px;\n  border: 1px solid #dbe6ff;\n  border-radius: 8px;\n  background: #f8fbff;\n}\n\n.project-readiness-context {\n  margin-top: 4px;\n}\n\n.project-readiness-badge-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  margin-top: 14px;\n}\n\n.project-readiness-badge,\n.project-readiness-confidence {\n  display: inline-flex;\n  align-items: center;\n  min-height: 34px;\n  padding: 6px 12px;\n  border-radius: 999px;\n  background: #eff6ff;\n  color: #1d4ed8;\n  font-size: 0.9rem;\n  font-weight: 600;\n}\n\nhtml[data-brand=\"house-helper\"] .project-readiness-badge,\nhtml[data-brand=\"house-helper\"] .project-readiness-confidence {\n  background: #edf8e7;\n  color: #2f7d32;\n}\n\n.project-readiness-summary-copy {\n  margin-top: 14px;\n  color: #1f2937;\n  line-height: 1.6;\n}\n\n.project-readiness-list {\n  margin: 12px 0 0;\n  padding-left: 18px;\n  color: #374151;\n  line-height: 1.6;\n}\n\n.project-readiness-results-actions {\n  justify-content: flex-start;\n  padding-top: 12px;\n}\n\n.project-readiness-cta-link {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  text-decoration: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
